import { pageNames } from '@atc/bonnet-paths';
import setMakeDuckCreator from './creators/setMakeCreator';

export default setMakeDuckCreator({
    namespace: pageNames.DEALER_SEARCH,
    storePrefix: `${pageNames.DEALER_SEARCH}.`,
});
